import { CheckCircle2 } from 'lucide-react'

export function TicketDeliveryNotice() {
  return (
    <div className="border-success-subtle bg-success-subtle flex items-start gap-3 rounded-2xl border p-5 sm:p-6">
      <CheckCircle2 className="text-success-foreground mt-0.5 size-5 shrink-0" />
      <div className="flex flex-col gap-1">
        <p className="text-success-foreground text-base font-semibold">
          Votre dossier est bien soldé
        </p>
        <p className="text-success-foreground/90 text-sm">
          Vos billets seront disponibles et vous seront envoyés par email entre 45 et 30 jours
          avant le départ. Nous vous remercions pour votre confiance.
        </p>
      </div>
    </div>
  )
}
